module.exports = __webpack_public_path__ + "pg.svg?f2479bfd0b94e2e9ceb33e9e4c752628";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pg.svg
// module id = 1158
// module chunks = 27